import { useEffect, useRef, useState } from "react";
import {
  mostraAlertaError,
  mostraAlertaOk,
  mostraAlertaWarning,
} from "../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../componentes/axios/Axios";
import GestionUbicacion from "../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../componentes/modal/ModalBootstrap";
import {
  EmpleadoImagenEditar,
  EmpleadosEditar,
  EmpleadosListar,
  ImagenEmpleado,
  CargosListar,
} from "../../configuracion/apiUrls";
import { DireccionConfig, permisosPorRuta } from "../../configuracion/Empresa";
import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import {
  regexEmail,
  regexIdentidad,
  regexRTN,
  regexTelefono,
  regexNombreOpcionalValido,
  regexNombreValido
} from "../../configuracion/validaciones";

const mapAccesosToForm = (usuarioAccesos) => {
  return usuarioAccesos.map(acceso => ({
    ruta: acceso.ruta,
    permisos: acceso.permisos ? acceso.permisos.split(',').map(p => p.trim()).sort() : [],
    estado: acceso.estado
  }));
};

const ModalEmpleado = ({ datos }) => {
  const { token } = useContextUsuario();
  const { listaCargos, setListaEmpleados, ActualizarLista, setListaCargos } =
    useContextEmpleado();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cargoId, setCargoId] = useState(datos ? datos.cargoId : null);
  const [formularioEmpleados, setFormularioEmpleados] = useState({
    id: datos ? datos.id : null,
    correo: datos ? datos.correo : "",
    rtn: datos ? datos.rtn : "",
    identidad: datos ? datos.identidad : "",
    primerNombre: datos ? datos.primerNombre : "",
    segundoNombre: datos ? datos.segundoNombre : "",
    primerApellido: datos ? datos.primerApellido : "",
    segundoApellido: datos ? datos.segundoApellido : "",
    cargoId: datos ? datos.cargoId : null,
    telefonos: datos ? datos.EmpleadoTelefonos : [{ telefono: "" }],
    direcciones: datos
      ? datos.EmpleadoDireccions
      : [{ direccion: "", longitud: null, latitud: null }],
    genero: datos ? datos.genero : "",
    activo: true,
    imagen: datos ? datos.imagen : "empleados.jpeg",
    nombre: datos && datos.Usuario ? datos.Usuario.nombre : "",
  });

  const generos = [
    { value: 1, label: "Masculino" },
    { value: 2, label: "Femenino" },
  ];

  const [generoId, setGeneroId] = useState(
    datos && datos.genero
      ? generos.find((opcion) => opcion.label === datos.genero)?.value || null
      : null
  );

  const cargos = listaCargos.map((f) => ({
    value: f.id,
    label: f.nombre_cargo,
  }));

  const [errorrtn, setErrorrtn] = useState(false);
  const [errorIdentidad, setErrorIdentidad] = useState(false);
  const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
  const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
  const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
  const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState(false);
  const [errorCargo, setErrorCargo] = useState(false);
  const [errorTelefonos, setErrorTelefonos] = useState([]);

  const [accesosForm, setAccesosForm] = useState({ accesos: [] });
  const [areaSeleccionada, setAreaSeleccionada] = useState("");

  useEffect(() => {
              if (!Array.isArray(listaCargos) || listaCargos.length === 0) {
                  ActualizarLista(CargosListar, setListaCargos);
              }
          }, [ActualizarLista, listaCargos, setListaCargos]);
  

  // Efecto para sincronizar el género en formularioEmpleados
  useEffect(() => {
    const genero = generoId
      ? generos.find((opcion) => opcion.value === generoId)?.label
      : "";
    setFormularioEmpleados((prevState) => ({
      ...prevState,
      genero: genero,
    }));
  }, [generoId, setFormularioEmpleados]);

  useEffect(() => {
    setFormularioEmpleados((prev) => ({
      ...prev,
      cargoId: cargoId,
    }));
  }, [cargoId]);

  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      //agregarDireccion();
      console.log(formularioEmpleados.direcciones.length);
      setFormularioEmpleados((prevState) => ({
        ...prevState,
        direcciones: [...prevState.direcciones, nuevaDireccion],
      }));
      setSeleccionarDireccion(false);
      //setNuevaDireccion({ direccion: "Dirección: H5V4+2Q2, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras", longitud: -87.84306461526864, latitud: 14.592255371946488 });
    }
  }, [seleccionarDireccion]);

  useEffect(() => {
    setErrorPrimerNombre(!regexNombreValido.test(formularioEmpleados.primerNombre));
    setErrorPrimerApellido(!regexNombreValido.test(formularioEmpleados.primerApellido));

    if (regexEmail.test(formularioEmpleados.correo)) {
      setErrorCorreo(false);
    } else {
      setErrorCorreo(true);
    }

    if (formularioEmpleados.primerNombre.length < 3) {
      setErrorPrimerNombre(true);
    } else {
      setErrorPrimerNombre(false);
    }

    if (formularioEmpleados.primerApellido.length < 3) {
      setErrorPrimerApellido(true);
    } else {
      setErrorPrimerApellido(false);
    }

    const segundoNombre = formularioEmpleados.segundoNombre || '';
    if (segundoNombre.trim()) {
      setErrorSegundoNombre(
        !regexNombreOpcionalValido.test(segundoNombre)
      );
    } else {
      setErrorSegundoNombre(false);
    }

    const segundoApellido = formularioEmpleados.segundoApellido || '';
    if (segundoApellido.trim()) {
      setErrorSegundoApellido(
        !regexNombreOpcionalValido.test(segundoApellido)
      );
    } else {
      setErrorSegundoApellido(false);
    }

    const rtnValue = formularioEmpleados.rtn || '';
    if (rtnValue.trim() !== "") {
      if (!regexRTN.test(rtnValue.trim())) {
        setErrorrtn(true);
      } else {
        setErrorrtn(false);
      }
    } else {
      setErrorrtn(false);
    }

    const identidadValue = formularioEmpleados.identidad || '';
    if (identidadValue.trim() !== "") {
      if (!regexIdentidad.test(identidadValue.trim())) {
        setErrorIdentidad(true);
      } else {
        setErrorIdentidad(false);
      }
    } else {
      setErrorIdentidad(false);
    }

    if (!formularioEmpleados.cargoId) {
      setErrorCargo(true);
    } else {
      setErrorCargo(false);
    }
    const nuevosErrores = formularioEmpleados.telefonos.map((numero) =>
      !regexTelefono.test(numero.telefono)
    );
    setErrorTelefonos(nuevosErrores);
  }, [formularioEmpleados]);

  useEffect(() => {
    var genero = "M";
    if (generoId === 2) genero = "F";
    setFormularioEmpleados({
      ...formularioEmpleados,
      genero: genero,
    });
  }, [generoId]);

  useEffect(() => {
    if (modalIsOpen) {
      setFormularioEmpleados({
        id: datos ? datos.id : null,
        correo: datos ? datos.correo : "",
        rtn: datos ? datos.rtn : "",
        identidad: datos ? datos.identidad : "",
        primerNombre: datos ? datos.primerNombre : "",
        segundoNombre: datos ? datos.segundoNombre : "",
        primerApellido: datos ? datos.primerApellido : "",
        segundoApellido: datos ? datos.segundoApellido : "",
        cargoId: datos ? datos.cargoId : null,
        telefonos: datos ? datos.EmpleadoTelefonos : [{ telefono: "" }],
        direcciones: datos
          ? datos.EmpleadoDireccions
          : [{ direccion: "", longitud: null, latitud: null }],
        genero: datos ? datos.genero : "",
        activo: true,
        imagen: datos ? datos.imagen : "empleados.jpeg",
        nombre: datos && datos.Usuario ? datos.Usuario.nombre : "",
      });

      setGeneroId(
        datos && datos.genero
          ? generos.find((opcion) => opcion.label === datos.genero)?.value || null
          : null
      );

      // Inicialización de accesos para edición
      if (datos && datos.Usuario && datos.Usuario.UsuarioAccesos) {
        setAccesosForm({ accesos: mapAccesosToForm(datos.Usuario.UsuarioAccesos) });
      } else {
        setAccesosForm({ accesos: [] });
      }
      setAreaSeleccionada("");
    }
  }, [modalIsOpen]);

  const manejadorEmpleados = (event) => {
    setFormularioEmpleados({
      ...formularioEmpleados,
      [event.target.name]: event.target.value,
    });
  };

  const manejarCambioNumeros = (index, value) => {
    const nuevosNumeros = [...formularioEmpleados.telefonos];
    nuevosNumeros[index] = { telefono: value };

    setFormularioEmpleados({
      ...formularioEmpleados,
      telefonos: nuevosNumeros,
    });
  };

  const agregarNumero = () => {
    setFormularioEmpleados((prevState) => ({
      ...prevState,
      telefonos: [...prevState.telefonos, { telefono: "" }],
    }));
  };

  const eliminarNumero = (index) => {
    setFormularioEmpleados((prevState) => {
      const nuevosNumeros = [...prevState.telefonos];
      nuevosNumeros.splice(index, 1);
      return { ...prevState, telefonos: nuevosNumeros };
    });
  };

  const eliminarDireccion = (index) => {
    setFormularioEmpleados((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };

  const togglePermiso = (ruta, permiso) => {
    let updatedAccesos = [...accesosForm.accesos];
    let selectedIndex = updatedAccesos.findIndex(acc => acc.ruta === ruta);

    if (selectedIndex === -1) return;

    const acc = updatedAccesos[selectedIndex];
    const currentPermisos = Array.isArray(acc.permisos) ? acc.permisos : acc.permisos.split(',').map(p => p.trim());

    const permisos = currentPermisos.includes(permiso)
      ? currentPermisos.filter(p => p !== permiso)
      : [...currentPermisos, permiso];

    updatedAccesos[selectedIndex] = { ...acc, permisos: permisos.sort() };

    setAccesosForm({ accesos: updatedAccesos });
  };

  const toggleRuta = (ruta) => {
    const existe = accesosForm.accesos.find(acc => acc.ruta === ruta);
    if (!existe) {
      setAccesosForm({ ...accesosForm, accesos: [...accesosForm.accesos, { ruta, permisos: [], estado: "Activo" }] });
    }
  };


  const BotonGuardar = () => {
    return (
      <button
        type="button"
        className="btn btn-primary"
        onClick={guardarEmpleado}
      >
        Guardar
      </button>
    );
  };
  const BotonEditar = () => {
    return (
      <button type="button" className="btn btn-warning" onClick={editarEmpleado}>
        Editar
        <i className="fas fa-edit mr-1 mx-1" />
      </button>
    );
  };
  const guardarEmpleado = () => { };

  const quitarCamposVacios = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== null && obj[key] !== undefined) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  const editarEmpleado = () => {
    if (
      errorPrimerNombre ||
      errorPrimerApellido ||
      errorCargo ||
      errorIdentidad ||
      errorCorreo ||
      errorrtn ||
      errorSegundoNombre ||
      errorSegundoApellido ||
      errorTelefonos.includes(true)
    ) {
      mostraAlertaWarning("Existen errores en la introducción de campos");
      return;
    }

    try {
      const direccionesVacia = formularioEmpleados.direcciones.filter(
        (f) => f.direccion !== "" || f.longitud !== null || f.latitud !== null
      );
      const telefonosVacia = formularioEmpleados.telefonos.filter(
        (f) => f.telefono !== "" && f.telefono !== null
      );

      const datosAEnviar = {
        ...formularioEmpleados,
        direcciones: direccionesVacia,
        telefonos: telefonosVacia,
        accesos: accesosForm.accesos,
      };

      const nuevosDatos = quitarCamposVacios(datosAEnviar);

      AxiosPrivado.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
      AxiosPrivado.put(
        EmpleadosEditar + formularioEmpleados.id,
        nuevosDatos
      )
        .then((respuesta) => {
          ActualizarLista(EmpleadosListar, setListaEmpleados);
          mostraAlertaOk("Registro actualizado correctamente");
          setModalIsOpen(false);
        })
        .catch((er) => {
          console.log(er);
          var msjError = "";
          switch (er.response?.status) {
            case 400:
              if (er.response.data?.error && Array.isArray(er.response.data.error)) {
                er.response.data.error.map((f) => {
                  msjError += f.msg + ". ";
                });
              } else if (er.response.data?.error) {
                msjError = er.response.data.error;
              }
              break;
            case 500:
              msjError = er.response.data.error || "Error interno del servidor";
              break;
            default:
              msjError = "Ocurrió un error desconocido.";
              break;
          }
          mostraAlertaError(msjError, "error");
        });
    } catch (error) {
      mostraAlertaError("Error en la pedición");
    }
  };

  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    } else {
      try {
        let formData = new FormData();
        formData.append("imagen", event.target.files[0]);
        await AxiosImagen.put(
          EmpleadoImagenEditar + formularioEmpleados.id,
          formData
        )
          .then((respuesta) => {
            console.log(respuesta);
            setFormularioEmpleados((prevState) => ({
              ...prevState,
              imagen: respuesta.data.imagen,
            }));
            ActualizarLista(EmpleadosListar, setListaEmpleados);
            mostraAlertaOk("Imagen actualizada correctamente");
          })
          .catch((er) => {
            console.log(er);
            var msjError = "";
            switch (er.response?.status) {
              case 400:
                if (
                  er.response.data.error &&
                  Array.isArray(er.response.data.error)
                ) {
                  er.response.data.error.map((f) => {
                    msjError += f.msg + ". ";
                  });
                } else if (er.response.data.error) {
                  msjError = er.response.data.error;
                }
                break;
              case 500:
                msjError = er.response.data.error || "Error interno del servidor";
                break;
              default:
                msjError = "Ocurrió un error desconocido.";
                break;
            }
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al actualizar la imagen");
      }
    }
  };

  const SeleccionarImagen = () => {
    //console.log("Haciendo clic en SeleccionarImagen");
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  const inputRef = useRef(null);

  return (
    <ModalBootstrap
      titulo={datos ? "Editar Empleado" : "Nuevo Empleado"}
      nombreBoton={datos ? "" : "Nuevo Empleado"}
      estiloBoton={datos ? "btn btn-outline-primary" : "btn btn-info"}
      iconBoton={datos ? "fas fa-edit mx-0" : "fas fa-user-plus"}
      pie={datos ? <BotonEditar /> : <BotonGuardar />}
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
    >
      <div className="row">
        <div className="col-sm-4 col-lg-2">
          <div className="form-group">
            <div className="text-center">
              <img
                className="product-image"
                src={ImagenEmpleado + formularioEmpleados.imagen}
                alt="Foto"
                crossOrigin="anonymous"
              />
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={inputRef}
              onChange={handleFileChange}
            />
            <button
              type="button"
              className="btn btn-block btn-outline-info btn-xs"
              onClick={SeleccionarImagen}
            >
              Actualizar
            </button>
          </div>
        </div>
        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">RTN</label>
            <input
              type="text"
              className={`form-control ${errorrtn ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese la rtn"
              name="rtn"
              value={formularioEmpleados.rtn || ""}
              onChange={manejadorEmpleados}
            />
            {errorrtn && (
              <div className="invalid-feedback">
                El RTN debe tener exactamente 14 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Identidad</label>
            <input
              type="text"
              className={`form-control ${errorIdentidad ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese la rtn"
              name="identidad"
              value={formularioEmpleados.identidad || ""}
              onChange={manejadorEmpleados}
            />
            {errorIdentidad && (
              <div className="invalid-feedback">
                La identidad debe tener exactamente 13 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Correo</label>
            <input
              type="text"
              className={`form-control ${errorCorreo ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese el correo"
              name="correo"
              value={formularioEmpleados.correo}
              onChange={manejadorEmpleados}
            />
            {errorCorreo && (
              <div className="invalid-feedback">
                Correo electrónico inválido
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerNombre">Primer nombre</label>
            <input
              type="text"
              className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Primer Nombre"
              name="primerNombre"
              value={formularioEmpleados.primerNombre}
              onChange={manejadorEmpleados}
            />
            {errorPrimerNombre && (
              <div className="invalid-feedback">
                El primer nombre debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoNombre">Segundo nombre</label>
            <input
              type="text"
              className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Segundo Nombre"
              name="segundoNombre"
              value={formularioEmpleados.segundoNombre}
              onChange={manejadorEmpleados}
            />
            {errorSegundoNombre && (
              <div className="invalid-feedback">
                El segundo nombre debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerApellido">Primer apellido</label>
            <input
              type="text"
              className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Primer Apellido"
              name="primerApellido"
              value={formularioEmpleados.primerApellido}
              onChange={manejadorEmpleados}
            />
            {errorPrimerApellido && (
              <div className="invalid-feedback">
                El primer apellido debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoApellido">Segundo apellido</label>
            <input
              type="text"
              className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Segundo Apellido"
              name="segundoApellido"
              value={formularioEmpleados.segundoApellido}
              onChange={manejadorEmpleados}
            />
            {errorSegundoApellido && (
              <div className="invalid-feedback">
                El segundo apellido debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <label>Teléfonos</label>
          <div className="row">
            <div className="col-sm-9">
              <div className="form-group">
                {formularioEmpleados.telefonos.map((numero, index) => (
                  <div key={index} className="input-group mb-3">
                    <input
                      type="text"
                      className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                      placeholder="Ej: 98908767"
                      name="telefono"
                      value={numero.telefono}
                      onChange={(event) =>
                        manejarCambioNumeros(index, event.target.value)
                      }
                    />
                    {formularioEmpleados.telefonos.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger mx-2"
                        onClick={() => eliminarNumero(index)}
                        width="20px"
                      >
                        <i className="fa fa-minus" aria-hidden="true"></i>
                      </button>
                    )}
                    {errorTelefonos[index] && (
                      <div className="invalid-feedback">
                        Número inválido. Debe tener entre 8 y 12 dígitos.
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={agregarNumero}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Cargo</label>
            <select
              className="form-control select2bs4"
              style={{ width: "100%" }}
              value={cargoId || ""}
              onChange={(e) => {
                setCargoId(e.target.value);
              }}
            >
              <option value="">Seleccione un cargo</option>
              {cargos.map((cargo) => (
                <option key={cargo.value} value={cargo.value}>
                  {cargo.label}
                </option>
              ))}
            </select>
            {errorCargo && (
              <small className="text-danger">Debe seleccionar un cargo</small>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <label>Direcciones</label>
          <div className="pb-3">
            <GestionUbicacion
              direccion={nuevaDireccion}
              setDireccion={setNuevaDireccion}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setSeleccionarDireccion={setSeleccionarDireccion}
              textoBoton={"Agregar Ubicación"}
              verdireccion={false}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            {formularioEmpleados.direcciones.map((f, index) => (
              <div key={index} className="row">
                <div className="col-9">
                  <p className="text-muted">{f.direccion}</p>
                </div>
                <div className="col-3">
                  <VerUbicacion key={index} direccion={f} />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => eliminarDireccion(index)}
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Genero</label>
            <select
              className="form-control select2bs4"
              style={{ width: "100%" }}
              value={generoId || ""}
              onChange={(e) => {
                setGeneroId(e.target.value);
              }}
            >
              <option value="">Seleccione un género</option>
              {generos.map((genero) => (
                <option key={genero.value} value={genero.value}>
                  {genero.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-sm-2">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Estado</label>
            <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
              <input
                type="checkbox"
                className="custom-control-input"
                id="customSwitch3"
                name="activo"
                checked={formularioEmpleados.activo}
                onChange={(event) => {
                  setFormularioEmpleados({
                    ...formularioEmpleados,
                    activo: event.target.checked,
                  });
                }}
              />
              <label className="custom-control-label" htmlFor="customSwitch3">
                {formularioEmpleados.activo ? "Activo" : "Inactivo"}
              </label>
            </div>
          </div>
        </div>
      </div>

      <hr className="my-4" />
      <h5>Configuracion de accesos</h5>
      <hr></hr>
      <p className="alert alert-info">
        NOTA: Edite los accesos y permisos de las rutas.
        <span className="badge bg-primary text-white ms-2">{accesosForm.accesos.length} Rutas Agregadas</span>
      </p>

      {/* Accesos disponibles (Selección de módulo) */}
      <div className="border rounded shadow-sm p-3 mb-4">
        <h5 className="mb-3 fw-bold">1. Seleccione un módulo para configurar</h5>
        <div className="row gx-3 gy-3">
          {Object.entries(permisosPorRuta).map(([nombre, { ruta }]) => (
            <div key={ruta} className="col-6 col-sm-4 col-md-3 col-lg-2 my-1">
              <button
                type="button"
                className={`btn w-100 text-truncate transition ${areaSeleccionada === ruta ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setAreaSeleccionada(ruta)}
              >
                {areaSeleccionada === ruta ? "✓ " : ""}{nombre}
              </button>
            </div>
          ))}
        </div>
      </div>
      {/* Configuración de permisos */}
      {areaSeleccionada && (() => {
        const entry = Object.entries(permisosPorRuta).find(([_, v]) => v.ruta === areaSeleccionada);
        if (!entry) return null;
        const [nombre, { ruta, permisos }] = entry;
        const selected = accesosForm.accesos.find(acc => acc.ruta === ruta);

        // Verifica si ya existe para usar el botón de "Acceso Agregado"
        const existeAccesoInicial = datos?.Usuario?.UsuarioAccesos?.some(acc => acc.ruta === ruta);

        return (
          <div className="card shadow-sm mb-4 animate__animated animate__fadeIn">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title mb-0 text-secondary">
                  <i className="bi bi-shield-lock-fill me-2"></i>
                  2. Permisos para: <span className="text-primary">{nombre}</span>
                </h5>
                <button
                  type="button"
                  className={`btn btn-sm ${selected ? 'btn-secondary disabled' : 'btn-outline-success'}`}
                  onClick={() => toggleRuta(ruta)}
                  disabled={!!selected}
                >
                  {selected ? "Acceso Agregado" : "Agregar Acceso"}
                </button>
              </div>

              {selected && (
                <div className="row">
                  {permisos.map((perm, idx) => (
                    <div className="form-check col-md-6 col-lg-4 mb-3" key={idx}>
                      <input
                        className="form-check-input rounded shadow-sm"
                        type="checkbox"
                        checked={Array.isArray(selected.permisos) ? selected.permisos.includes(perm) : selected.permisos.split(',').map(p => p.trim()).includes(perm)}
                        onChange={() => togglePermiso(ruta, perm)}
                        id={`${ruta}-${perm}`}
                      />
                      <label className="form-check-label ms-3 fw-semibold fs-6 text-dark" htmlFor={`${ruta}-${perm}`}>
                        {perm}
                      </label>
                    </div>
                  ))}
                  <div className="col-12 mt-3">
                    <label className="form-label fw-semibold">Estado del acceso:</label>
                    <select
                      className="px-3 py-2 mx-2 rounded-md bg-gray-100 text-gray-700 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                      value={selected.estado}
                      onChange={(e) => {
                        const updated = accesosForm.accesos.map(acc =>
                          acc.ruta === ruta ? { ...acc, estado: e.target.value } : acc
                        );
                        setAccesosForm({ ...accesosForm, accesos: updated });
                      }}
                    >
                      <option value="Activo">Activo</option>
                      <option value="Bloqueado">Bloqueado</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

    </ModalBootstrap>
  );
};
export default ModalEmpleado;